/**
 * Unde duce un „Open" dintr-un panou de descoperire.
 *
 * Panourile de descoperire (Data Collection, Discovery Setup, Discovery
 * Credentials, Scan Rules) au DOUA usi: filele setarilor Softsee
 * (`/settings/softsee/<fila>`) si intrarile zonei Policies (`/settings/telemetry`,
 * `/settings/discovery_setup`, `/settings/vault`, `/settings/scan_rules`).
 * Fiecare usa are meniul ei in stanga.
 *
 * Un „Open" scris mereu spre fila Softsee scotea omul din Policies: din
 * Policies > Discovery Setup, „Open" la regulile de scanare deschidea
 * Softsee, cu meniul lui, si CI Rules nu se mai vedea. Deci: daca esti pe o
 * usa Policies si fila are pereche acolo, ramai in Policies.
 *
 * Adresa se citeste in clipa clicului, nu dintr-un hook: panourile se
 * deseneaza si in probe care nu pun router.
 */
const POLICIES: Record<string, string> = {
  telemetry: '/settings/telemetry',
  discovery_setup: '/settings/discovery_setup',
  credentials: '/settings/vault',
  scan_rules: '/settings/scan_rules',
}

const POLICIES_PATHS = new Set(Object.values(POLICIES))

export function discoveryTabTarget(tab: string, pathname: string = currentPath()): string {
  const here = pathname.replace(/^\/app(?=\/)/, '').replace(/\/+$/, '')
  const door = POLICIES[tab]
  if (door !== undefined && POLICIES_PATHS.has(here)) return door
  return '/settings/softsee/' + tab
}

function currentPath(): string {
  return typeof window === 'undefined' ? '' : window.location.pathname
}
